import * as translator from "../../../../utils/translator";

interface CarePlusHeroProps {
    language?: string;
    customerEmail?: string;
}

export default function CarePlusHero({ language, customerEmail }: CarePlusHeroProps) {

    const [beforeEmail, afterEmail = ""] = (translator.translate(language, "thankyou", "page/care_plus_email_subtitle") || "").split(":email");
    // Punctuation right after the address ("…to.") stays on its line instead of wrapping alone.
    const [, gluedToEmail, restAfterEmail] = afterEmail.match(/^(\S*)([\s\S]*)$/)!;

    return (
        <div className="care-plus-hero">
            <div className="care-plus-hero-check" aria-hidden="true">
                <svg width="34" height="34" viewBox="0 0 24 24" fill="none">
                    <path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </div>
            <p className="care-plus-hero-title">
                <span className="care-plus-hero-title-highlight">
                    {translator.translate(language, "thankyou", "page/care_plus_hero_title_highlight")}
                </span>
                {translator.translate(language, "thankyou", "page/care_plus_hero_title_rest")}
            </p>
            <p className="care-plus-hero-subtitle">
                {beforeEmail}
                <span className="care-plus-hero-email">{customerEmail}{gluedToEmail}</span>
                {restAfterEmail}
            </p>
        </div>
    )
}
